import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
@Component({
  selector: 'lib-table-headers',
  templateUrl: './table-headers.component.html',
  styleUrls: ['./table-headers.component.scss']
})
export class TableHeadersComponent implements OnInit {
  @Input()
  headers: ITableHeaderConfig;
  constructor() { }

  ngOnInit() {
  }
  clickOnHeader(obs: Observable<string>, func: (value?: string) => undefined, header) {
    typeof header.clickAction !== 'function' ? this.changeSort(obs) : undefined;
    obs.pipe(take(1)).subscribe(next => {
      typeof header.clickAction === 'function' ? header.clickAction(next) : undefined;
    })
  }
  renderClass(header: ITableHeader, name: string) {
    const nameClass = 'h-' + name;
    return { nameClass: true, 'sortable': header.sortable };
  }
  changeSort(obs: Observable<string>) {

    obs.pipe(take(1)).subscribe(category => {

      if (category === this.headers.default_category) {
        this.headers.filter_service.sortLocator.asc = !this.headers.filter_service.sortLocator.asc;
        this.headers.filter_service.sortLocator.sortingType = category as any;
        this.headers.filter_service.sortLocator.modifyOrderValue();
        return;
      }
      if (category === undefined) {

        this.headers.filter_service.sortLocator.sortingType = undefined;
        this.headers.filter_service.sortLocator.asc = true;
      } else {
        if (category === this.headers.filter_service.sortLocator.sortingType) {

          if (this.headers.filter_service.sortLocator.asc === false) {
            this.headers.filter_service.sortLocator.sortingType = undefined;
          }
          this.headers.filter_service.sortLocator.asc = !this.headers.filter_service.sortLocator
            .asc;
        } else {

          this.headers.filter_service.sortLocator.sortingType = category as any;
          this.headers.filter_service.sortLocator.asc = true;
        }
      }

      this.headers.filter_service.modifyOrderValue();
    }
    )
  }
  sortClass(category: string) {
    if (this.headers.filter_service.sortLocator.sortingType !== category) {
      return '';
    }
    return this.headers.filter_service.sortLocator.asc === true ? 'asc' : 'desc';
  }
}
export interface ISortableService<T = any> {
  sortLocator: any
  modifyOrderValue()

}
export interface ITableHeaderConfig<T=any> {
  headers: Array<ITableHeader>;
  filter_service?: ISortableService<T>
  default_category?: string;
}
export interface ITableHeader {
  name: Observable<string>;
  sortable: boolean;
  callbackStyle?: (value?: string) => string;
  clickAction?: (value?: string) => undefined;
}
